module.exports = __webpack_public_path__ + "static/img/quantijingyin.b97b9a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/quantijingyin.png
// module id = qSJv
// module chunks = 24